import { FuelUnit } from '@fe/core';
import { FuelVolumeUnits, FuelWeightUnits } from '../types';

export function convertFuel(value: number, sourceUnit: FuelUnit, targetUnit: FuelUnit): number {
    if (targetUnit === FuelUnit.Null) {
        return value;
    }

    switch (sourceUnit) {
        case FuelUnit.Null:
            return value;

        case FuelUnit.WeighPounds:
            if (targetUnit === FuelUnit.WeighPounds) {
                return value;
            }

            if (targetUnit === FuelUnit.WeightKilograms) {
                return value / 2.204622622;
            }

            throw new Error('Incompatible units');

        case FuelUnit.WeightKilograms:
            if (targetUnit === FuelUnit.WeightKilograms) {
                return value;
            }
            if (targetUnit === FuelUnit.WeighPounds) {
                return value * 2.204622622;
            }

            throw new Error('Incompatible units');

        case FuelUnit.VolumeGallons:
            if (targetUnit === FuelUnit.VolumeGallons) {
                return value;
            }

            if (targetUnit === FuelUnit.VolumeLiters) {
                return value * 3.78541;
            }

            throw new Error('Incompatible units');

        case FuelUnit.VolumeLiters:
            if (targetUnit === FuelUnit.VolumeLiters) {
                return value;
            }

            if (targetUnit === FuelUnit.VolumeGallons) {
                return value / 3.78541;
            }

            throw new Error('Incompatible units');
    }
}

export function convertUnit(value: FuelUnit, weightUnit: FuelWeightUnits, volumeUnit: FuelVolumeUnits): FuelUnit {
    switch (value) {
        case FuelUnit.VolumeGallons:
        case FuelUnit.VolumeLiters:
            if (volumeUnit === FuelVolumeUnits.gallon) {
                return FuelUnit.VolumeGallons;
            }
            return FuelUnit.VolumeLiters;

        case FuelUnit.WeighPounds:
        case FuelUnit.WeightKilograms:
            if (weightUnit === FuelWeightUnits.pound) {
                return FuelUnit.WeighPounds;
            }
            return FuelUnit.WeightKilograms;
        default:
            return FuelUnit.Null;
    }
}
